<div class="text-center" [ngClass]="componentClass">
    <div class="font-weight-normal" [ngClass]="{'h4': size === 'md', 'h2': size === 'lg', 'h6': size==='sm'}">
        <fa-icon *ngIf="spinner" [icon]="['far', spinner]" animation="spin-pulse" size="lg"></fa-icon>
        <div
            [ngClass]="{'mt-2': size === 'md' && !horizontal, 'mt-3': size === 'lg' && !horizontal, 'mt-1': size==='sm' && !horizontal, 'mt-0 d-inline-block ml-2': horizontal}">
            <span qwykTypingAnimation *ngIf="typing" [typeSpeed]="60" [startDelay]="200" [text]="text">{{ text }}</span>
            <span *ngIf="!typing">{{ text }}</span>
        </div>
    </div>
</div>
